import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { login } from "services/authService";

export default function Login() {
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    toast.info("Processing");

    if (email === "" || password === "")
      return toast.error("All fields are compulsory!");
    try {
      await login(email, password);
      toast.success("Login Successful");
      window.location.reload();
    } catch (err) {
      console.log(err);
      toast.error(err.response?.data);
    }
  }
  return (
    <>
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <h6 className="text-black-800 text-sm font-bold">
                    Sign in with credentials
                  </h6>
                </div>
                <hr className="mt-6 border-b-1 border-blueGray-300" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form onSubmit={handleSubmit}>
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        id="customCheckLogin"
                        type="checkbox"
                        className="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                      />
                      <span className="ml-2 text-sm font-semibold text-blueGray-600">
                        Remember me
                      </span>
                    </label>
                  </div>

                  <div className="text-center mt-6">
                    <button
                      className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleSubmit}
                    >
                      Sign In
                    </button>
                  </div>
                </form>
                <div className="w-1/2" style={{padding:"1%", with:"100%"}}>
                <Link
                  to="/auth/generateResetCode"
                    className="text-blueGray-200 text-sm font-bold uppercase"
                    style={{color:"black"}}
                >
                  <small>Reset Password</small>
                </Link>
              </div>
              <div className="w-1/2" style={{width:"100%"}}>
                <Link to="/auth/register" className="text-blueGray-200 text-sm font-bold uppercase" style={{color:"black"}}>
                  <small>New to ESL? Create new account</small>
                </Link>
              </div>

              </div>
            </div>
            {/* <div className="bg-blueGray-800 text-white flex flex-wrap mt-6 relative" style={{borderRadius:"5px"}}>
              <div className="w-1/2" style={{padding:"1%"}}>
                <a
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  className="text-blueGray-200 text-sm font-bold uppercase"
                >
                  <small>Forgot password?</small>
                </a>
              </div>
              <div className="w-1/2 text-right"  style={{padding:"1%"}}>
                <Link to="/auth/register" className="text-blueGray-200 text-sm font-bold uppercase">
                  <small>Create new account</small>
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
